export default __webpack_public_path__ + "static/media/logoWords.b73a0348.svg";